export default class GalleryLightbox {
  constructor() {
    this.onClick = (e) => {
      const item = e.target.closest('.tournament__gallery-item');
      const dialog = e.target.closest('.tournament__lightbox');

      if (item) {
        e.preventDefault();
        e.stopPropagation();
        this.open(item);
      } else if (dialog) {
        this.control(dialog, e.target);
      }
    };
    this.onKey = (e) => {
      const dialog = document.querySelector('.tournament__lightbox[open]');

      if (dialog && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        this.show(dialog, this.index + (e.key === 'ArrowRight' ? 1 : -1));
      }
    };

    document.addEventListener('click', this.onClick, true);
    document.addEventListener('keydown', this.onKey);
  }

  open(item) {
    const dialog = document.querySelector('.tournament__lightbox');

    if (!dialog) {
      return;
    }

    this.items = [...item.closest('.tournament__gallery').querySelectorAll('.tournament__gallery-item')];
    this.show(dialog, this.items.indexOf(item));
    dialog.showModal();
  }

  control(dialog, target) {
    if (target === dialog || target.closest('.tournament__lightbox-close')) {
      dialog.close();
    } else if (target.closest('.tournament__lightbox-prev')) {
      this.show(dialog, this.index - 1);
    } else if (target.closest('.tournament__lightbox-next')) {
      this.show(dialog, this.index + 1);
    }
  }

  show(dialog, index) {
    this.index = (index + this.items.length) % this.items.length;

    const item = this.items[this.index];
    const image = dialog.querySelector('.tournament__lightbox-image');

    image.src = item.href;
    image.alt = item.querySelector('img').alt;
    dialog.querySelector('.tournament__lightbox-caption').textContent = item.querySelector('span').textContent;
  }

  destroy() {
    document.removeEventListener('click', this.onClick, true);
    document.removeEventListener('keydown', this.onKey);
  }
}
